"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EditActionButton = function EditActionButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className,
      disabled = _ref.disabled,
      otherProps = _objectWithoutProperties(_ref, ["children", "onClick", "className", "disabled"]);

  return /*#__PURE__*/_react.default.createElement(StyledButton, _extends({
    onClick: onClick,
    disabled: disabled,
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement(_Icons.IconPencilFilled, {
    color: "#8990a3"
  }), /*#__PURE__*/_react.default.createElement("span", null, children));
};

var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "StyledButton"
})(["font-family:", ";font-size:1.6rem;border-radius:0.5rem;width:5.4rem;padding:1.2rem 0;display:flex;justify-content:center;align-items:center;background-color:#eef0f4;color:#8990a3;cursor:", ";border:0;> svg{margin:0;}> span{position:absolute;opacity:0;}:hover{width:auto;padding:1.2rem 1.8rem 1.2rem 0;> svg{padding-left:1.8rem;transition:margin 0.1s ease-in-out 5s,padding 0.2s ease-in-out;}> span{position:relative;opacity:1;margin-left:1rem;transition:opacity 0.2s ease-in-out 0.1s;}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}); // const Image = styled.img`
//   margin-right: 1rem;
//   height: 2rem;
// `;


EditActionButton.defaultProps = {
  otherProps: {},
  onClick: function onClick() {}
};
EditActionButton.propTypes = {
  disabled: _propTypes.bool,
  otherProps: _propTypes.object,
  className: _propTypes.string,
  onClick: _propTypes.func.isRequired,
  children: _propTypes.node.isRequired
};
var _default = EditActionButton;
exports.default = _default;